import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ModalComponentBaseProps, useModal } from '@pcmp/react-providers';
import { ModalHeader, Sheets, ModalBody } from '@ingka/modal';
import { useContentTracking } from '@/lib/hooks/tracking';
import ListView, { ListViewItem } from '@ingka/list-view';

const UsefulLinksSider: FC<ModalComponentBaseProps> = ({
  handleDismiss,
  ...rest
}) => {
  // Hooks
  const trackContent = useContentTracking();
  const { t } = useTranslation();
  const { openModal, closeModal } = useModal();

  useEffect(() => {
    trackContent('useful-links', { type: 'sider' });
  }, []);

  const goBack = async () => {
    await closeModal(0);
    const { default: HelpCenterSider } = await import('..');

    await openModal({
      component: HelpCenterSider,
      props: {},
    });
  };

  return (
    <Sheets
      {...rest}
      data-testid="usefulLinksModal"
      aria-label={t('page.usefulLinks.description')}
      footer={null}
      header={
        <ModalHeader
          ariaCloseTxt={t('aria.close')}
          title={t('page.usefulLinks.title')}
          backBtnClick={goBack}
        />
      }
    >
      <ModalBody>
        <ListView className="mt-6" id="report">
          <ListViewItem
            size="medium"
            emphasised
            title={t('page.usefulLinks.garments.title')}
            description={t('page.usefulLinks.garments.description')}
            control="link"
            controlIcon="linkOut"
            href="https://inter.ikea.net/toolbox/IKEA-Concept/Brand-identity-category/Co-worker-clothing/How-to_The-collection"
            newWindow="blank"
            className="no-underline"
          />
          <ListViewItem
            size="medium"
            emphasised
            title={t('page.usefulLinks.clothesCombinations.title')}
            description={t('page.usefulLinks.clothesCombinations.description')}
            control="link"
            controlIcon="linkOut"
            href="https://inter.ikea.net/toolbox/IKEA-Concept/Brand-identity-category/Co-worker-clothing/How-to_Combinations"
            newWindow="blank"
            className="no-underline"
          />
          <ListViewItem
            size="medium"
            emphasised
            title={t('page.usefulLinks.sizingGuide.title')}
            description={t('page.usefulLinks.sizingGuide.description')}
            control="link"
            controlIcon="linkOut"
            href="https://equipment.ikea.com/globalassets/ikea/commercecontent/main-cataloge/co-worker-clothing/coworker-clothing-size-table.pdf"
            newWindow="blank"
            className="no-underline"
          />
          <ListViewItem
            size="medium"
            emphasised
            title={t('page.usefulLinks.careInstructions.title')}
            description={t('page.usefulLinks.careInstructions.description')}
            control="link"
            controlIcon="linkOut"
            href="https://view.officeapps.live.com/op/view.aspx?src=https%3A%2F%2Fequipment.ikea.com%2Fglobalassets%2Fikea%2Fcommercecontent%2Fmain-cataloge%2Fco-worker-clothing%2Ftaking-care-of-your-co-worker-clothing.docx&wdOrigin=BROWSELINK"
            newWindow="blank"
            className="no-underline"
          />
          <ListViewItem
            size="medium"
            emphasised
            title={t('page.usefulLinks.adjustTshirt.title')}
            description={t('page.usefulLinks.adjustTshirt.description')}
            control="link"
            controlIcon="linkOut"
            href="https://equipment.ikea.com/globalassets/ikea/commercecontent/main-cataloge/co-worker-clothing/poloshirts/remove-hemming-stitch.mp4"
            newWindow="blank"
            className="no-underline"
          />
          <ListViewItem
            size="medium"
            emphasised
            title={t('page.usefulLinks.adjustTrouser.title')}
            description={t('page.usefulLinks.adjustTrouser.description')}
            control="link"
            controlIcon="linkOut"
            href="https://equipment.ikea.com/globalassets/ikea/commercecontent/main-cataloge/co-worker-clothing/bottoms/trousers-extension-instructions.pdf"
            newWindow="blank"
            className="no-underline"
          />
        </ListView>
      </ModalBody>
    </Sheets>
  );
};

export default UsefulLinksSider;
